import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from "react-bootstrap";
import { postRequest } from '../../helpers/apiHandler';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';

export const ResendEmailModal = ({ show, onHide }) => {
    const [email, setEmail] = useState("");
    const [alertState, setAlertState] = useState({
        message: "",
        show: false,
        variant: ""
    });

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const resendActivationEmail = () => {
        const data = { email: email };
        postRequest('/auth/resend-activation', data, "token", res => {
            if (res.success) {
                setAlertState({
                    message: "The verification email was resent. Please check your inbox.",
                    show: true,
                    variant: 'success',
                });
                onHide(false)
            } else {
                setAlertState({
                    message: res.message,
                    show: true,
                    variant: 'danger',
                });
            }
        });
    };

    useEffect(() => {
        if (alertState.show) {
            setTimeout(() => {
                setAlertState({
                    message: '',
                    show: false,
                    variant: '',
                });
            }, config.notify_time);
        }
    }, [alertState]);

    return (
     <>   
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="OutOfCreditModal"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Resend your email
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={handleEmailChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => onHide(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={resendActivationEmail}>
                    Resend Email
                </Button>
            </Modal.Footer>
        </Modal>
        <CustomAlert
            message={alertState.message}
            show={alertState.show}
            variant={alertState.variant}
            closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
        />
    </>
    );
};